import { PaymentRedirectOverlay } from "@/pages/ReservationOverview/components/PaymentRedirectOverlay/PaymentRedirectOverlay.tsx";
import { createRoot } from "react-dom/client";

export const showPaymentRedirectOverlay = (duration = 5000) => {
  return new Promise<void>((resolve) => {
    const container = document.createElement("div");
    document.body.appendChild(container);

    const handleComplete = () => {
      container.remove();
      resolve();
    };

    const root = createRoot(container);
    root.render(<PaymentRedirectOverlay duration={duration} onComplete={handleComplete} />);

    return {
      unmount: () => {
        root.unmount();
        container.remove();
        resolve();
      },
    };
  });
};
